import * as React from "react"
import { MerlinSourceEventsBySiteDocument } from "./queries.generated"
import { SplitButton, DropdownMenuItem } from "gatsby-interface"
import {
  useTriggerMerlinSourcingMutation,
  useTriggerClearCacheMerlinSourcingMutation,
} from "./mutations.generated"
interface ResourceDataButtonProps {
  siteId: string
}

export function ResourceDataButton({ siteId }: ResourceDataButtonProps) {
  const mutationOptions = {
    variables: {
      siteId,
    },
    refetchQueries: [
      {
        query: MerlinSourceEventsBySiteDocument,
        variables: {
          siteId,
        },
      },
    ],
  }

  const [triggerMerlinSourcingMutation, triggerSourcing] =
    useTriggerMerlinSourcingMutation(mutationOptions)

  const [triggerMerlinClearCacheSourcingMutation, triggerClearCacheSourcing] =
    useTriggerClearCacheMerlinSourcingMutation(mutationOptions)

  return (
    <SplitButton
      buttonLabel="Source content"
      dropdownButtonLabel="Other re-source options"
      disabled={triggerSourcing.loading}
      size="M"
      onClick={() => triggerMerlinSourcingMutation()}
    >
      <DropdownMenuItem
        disabled={triggerClearCacheSourcing.loading}
        onSelect={() => triggerMerlinClearCacheSourcingMutation()}
      >
        Clear cache and source content
      </DropdownMenuItem>
    </SplitButton>
  )
}
